import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";
import ScrollToTop from "@/components/ScrollToTop";

import HomePage from "@/pages/Home";
import ServicesPage from "@/pages/Services";
import PortfolioPage from "@/pages/Portfolio";
import AboutPage from "@/pages/About";
import ContactPage from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Header />
                <main data-testid="site-main">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/portfolio" element={<PortfolioPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>
                <Footer />
                <FloatingContact />
                <Toaster
                    position="bottom-left"
                    richColors
                    closeButton
                    toastOptions={{
                        style: {
                            fontFamily: "Manrope, sans-serif",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
